import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-describe-video-large.tsx
/**
* icon.24.describe.video.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE3LjUgMTlhLjUuNSAwIDAgMSAwIDFoLTRhLjUuNSAwIDAgMSAwLTF6bTMtMmEuNS41IDAgMCAxIDAgMWgtN2EuNS41IDAgMCAxIDAtMXpNMTMuMjA0IDQuMDFBMiAyIDAgMCAxIDE1IDZ2NS41YS41LjUgMCAwIDEtMSAwVjZhMSAxIDAgMCAwLTEtMUg1YTEgMSAwIDAgMC0xIDF2OGExIDEgMCAwIDAgMSAxaDYuNWEuNS41IDAgMCAxIDAgMUg1YTIgMiAwIDAgMS0xLjk5LTEuNzk2TDMgMTRWNmEyIDIgMCAwIDEgMi0yaDh6TTIwLjUgMTVhLjUuNSAwIDAgMSAwIDFoLTdhLjUuNSAwIDAgMSAwLTF6bTAtMmEuNS41IDAgMCAxIDAgMWgtN2EuNS41IDAgMCAxIDAtMXpNNi45OTggNy4xMzVhMSAxIDAgMCAxIC45OTgtLjAwM2wzLjUgMmExIDEgMCAwIDEgMCAxLjczNmwtMy41IDJBMSAxIDAgMCAxIDYuNSAxMlY4YTEgMSAwIDAgMSAuNDk4LS44NjVtLjUwMi44ODN2My45NjRhLjAxLjAxIDAgMCAwIC4wMTUuMDFsMy40Ny0xLjk4M2EuMDEuMDEgMCAwIDAgMC0uMDE4TDcuNTE0IDguMDFhLjAxLjAxIDAgMCAwLS4wMTUuMDA5Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=24953-59679
*/
const Icon24DescribeVideoLarge = memo(function Icon24DescribeVideoLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M17.5 19a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zm3-2a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zM13.204 4.01A2 2 0 0 1 15 6v5.5a.5.5 0 0 1-1 0V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6.5a.5.5 0 0 1 0 1H5a2 2 0 0 1-1.99-1.796L3 14V6a2 2 0 0 1 2-2h8zM20.5 15a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm0-2a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zM6.998 7.135a1 1 0 0 1 .998-.003l3.5 2a1 1 0 0 1 0 1.736l-3.5 2A1 1 0 0 1 6.5 12V8a1 1 0 0 1 .498-.865m.502.883v3.964a.01.01 0 0 0 .015.01l3.47-1.983a.01.01 0 0 0 0-.018L7.514 8.01a.01.01 0 0 0-.015.009"
		})
	});
});
//#endregion
export { Icon24DescribeVideoLarge };

//# sourceMappingURL=icon-24-describe-video-large.js.map